/* eslint-disable @typescript-eslint/no-explicit-any */
export const UpArrowIcon = () => (
	<svg
		width="6"
		height="4"
		viewBox="0 0 6 4"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.73434 1.53326L0.718282 3.54932L0.142383 2.97342L2.73434 0.381461L5.32629 2.97342L4.75039 3.54932L2.73434 1.53326Z"
			fill="rgba(237, 242, 247, 1)"
		/>
	</svg>
);

export const RightArrow = () => (
	<svg fill='#A0AEC0' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" /></svg>
);

export const DownArrowIcon = () => (
	<svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2.73435 2.33002L4.75041 0.313965L5.32631 0.889864L2.73435 3.48182L0.142395 0.889864L0.718295 0.313965L2.73435 2.33002Z" fill="rgba(237, 242, 247, 1)"/>
	</svg>
);

export const DotsOption = (props: any) => (
	<svg fill='#A0AEC0' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 128 512" {...props}><path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" /></svg>
);

export const TooltipHidden = (props: any) => (
	<svg
		fill='#A0AEC0'
		xmlns='http://www.w3.org/2000/svg'
		height='7px'
		viewBox='0 0 384 512'
		{...props}
	>
		<path d='M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z' />
	</svg>
);

export const TooltipShow = (props: any) => (
	<svg
		fill='#A0AEC0'
		xmlns='http://www.w3.org/2000/svg'
		width='7px'
		viewBox='0 0 320 512'
		{...props}
	>
		<path d='M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z' />
	</svg>
);

export const CheckboxO = (props: any) => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path id="Vector" d="M10.6667 1.33333V10.6667H1.33339V1.33333H10.6667ZM10.6667 0H1.33339C0.600061 0 6.10352e-05 0.6 6.10352e-05 1.33333V10.6667C6.10352e-05 11.4 0.600061 12 1.33339 12H10.6667C11.4001 12 12.0001 11.4 12.0001 10.6667V1.33333C12.0001 0.6 11.4001 0 10.6667 0Z" fill="#A0AEC0"/>
	</svg>
);

export const CheckboxNew = (props: any) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="Checkbox" clip-path="url(#clip0_1511_4177)">
			<path id="Vector" d="M12.6667 2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4067 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4067 2 12.6667 2ZM6.66667 11.3333L3.33333 8L4.27333 7.06L6.66667 9.44667L11.7267 4.38667L12.6667 5.33333L6.66667 11.3333Z" fill="#A0AEC0"/>
		</g>
		<defs>
			<clipPath id="clip0_1511_4177">
				<rect width="16" height="16" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

export const FolderClose = (props: any) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none" {...props}><path d="M6.64221 2.76465L5.37616 1.49854H1.6C1.26863 1.49854 1 1.76716 1 2.09854V9.90134C1 10.2327 1.26863 10.5013 1.6 10.5013H12.2468C12.5782 10.5013 12.8468 10.2327 12.8468 9.90134V3.36465C12.8468 3.03328 12.5782 2.76465 12.2468 2.76465H6.64221Z" fill="#A0AEC0" stroke="#A0AEC0" stroke-width="1.4" stroke-linecap="round" /></svg>
);

export const FolderOpen = (props: any) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none" {...props}><path d="M6.64221 2.76465L5.37616 1.49854H1.6C1.26863 1.49854 1 1.76716 1 2.09854V9.90134C1 10.2327 1.26863 10.5013 1.6 10.5013H12.2468C12.5782 10.5013 12.8468 10.2327 12.8468 9.90134V3.36465C12.8468 3.03328 12.5782 2.76465 12.2468 2.76465H6.64221Z" stroke="#A0AEC0" stroke-width="1.2" stroke-linecap="round" /></svg>
);
